import React from 'react';
import { RentalsTabValue } from 'services/types';
import { OrderInfo, OrderInfoDelivery } from 'common/types';
import BookedRentalCardStatus from './BookedRentalCardStatus';
import ActiveRentalCardStatus from './ActiveRentalCardStatus';
import CompletedRentalCardStatus from './CompletedRentalCardStatus';
import ExpiredRentalCardStatus from './ExpiredRentalCardStatus';

interface Props {
	rentalTab: RentalsTabValue;
	rentalInfo: OrderInfo;
	dateExpired?: boolean;
	delivery?: OrderInfoDelivery | undefined;
}

const RentalCardStatus = (props: Props) => {
	const { dateExpired, rentalTab, rentalInfo, delivery } = props;
	if (dateExpired) {
		return <ExpiredRentalCardStatus rentalInfo={rentalInfo} delivery={delivery} />;
	} else {
		switch (rentalTab) {
			case 'BOOKED':
				return (
					<BookedRentalCardStatus
						dateExpired={props.dateExpired}
						rentalInfo={rentalInfo}
						delivery={delivery}
					/>
				);
			case 'ACTIVE':
				return <ActiveRentalCardStatus rentalInfo={rentalInfo} delivery={delivery} />;
			case 'COMPLETED':
				return <CompletedRentalCardStatus rentalInfo={rentalInfo} />;
			default:
				return null;
		}
	}
};

export default RentalCardStatus;
